<template>
    <div>111111111111111111111111</div>
</template>

<script>
    export default {
        name: "test-0236",
        beforeRouteEnter(to,from,next){
            console.log('=======',from)
        }
    }
</script>

<style scoped>

</style>